/* The mockup's `confirmDialog`: `.scrim` + `.dialog` with head, body and foot. */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
  display: grid;
  place-items: start center;
  padding: 10vh var(--space-4) var(--space-4);
  overflow: auto;
  background-color: var(--scrim);
}

.dialog {
  inline-size: min(560px, 100%);
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
  color: var(--text);
  box-shadow: var(--shadow-dialog);
}

.title {
  margin: 0;
  padding: var(--space-4) var(--space-6) 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.body {
  margin: 0;
  padding: var(--space-4) var(--space-6);
  color: var(--text-muted);
  line-height: var(--line-height-body);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6) var(--space-4);
  border-top: 1px solid var(--border);
}
